/**
 * @class Translator
 */
class Translator {
    /**
     * @param {Object} translations
     * @constructor
     */
    constructor(translations = {}) {
        this.translations = translations;
    }

    /**
     * @param {String} key
     * @returns {String}
     */
    translate(key) {
        const translation = this.translations[key];
        if (!translation) {
            return key;
        }
        return translation;
    }
}

export default Translator;
